{
  "headings": {
    "header": {
      "navigation": {
        "whyUs": "Why Us",
        "features": "Features",
        "working": "Working",
        "pricing": "Pricing",
        "contact": "Contact"
      }
    },
    "hero": {
      "badge": "POS + Mobile Apps",
      "title": "Run Your Sales and Stock",
      "highlight": "From POS, Mobile, and Online Orders",
      "platformText": "POS with Customer Ordering Mobile Apps"
    },
    "apps": {
      "title": "One System, Three Apps",
      "subtitle": "Everything connected"
    },
    "features": {
      "title": "Features",
      "subtitle": "Everything you need to run your store"
    },
    "why": {
      "title": "Why Sale Mobilizer",
      "subtitle": "The POS system built for your success",
      "testimonials": "What Our Clients Say",
      "testimonialsSubtitle": "Results from businesses using Sale Mobilizer"
    },
    "working": {
      "title": "System Screens",
      "workflowTitle": "Screens",
      "tabs": {
        "pos": {
          "name": "POS Desktop",
          "icon": "fas fa-desktop",
          "categoryId": "pos-sales"
        },
      
        "admin": {
          "name": "Admin App",
          "icon": "fas fa-user-shield",
          "categoryId": "system-admin"
        },
        "customer": {
          "name": "Customer App",
          "icon": "fas fa-mobile-screen",
          "categoryId": "navigation-analytics"
        }
      },
      "altText": {
        "workflowStep": "Workflow Step",
        "modalImage": "Workflow Step Fullscreen",
        "previousImage": "Previous image",
        "nextImage": "Next image",
        "closeModal": "Close modal"
      },
      "ariaLabels": {
        "previousImage": "Previous image",
        "nextImage": "Next image",
        "closeModal": "Close modal"
      },
      "defaultIcon": "fas fa-folder"
    },
    "pricing": {
      "title": "Pricing",
      "subtitle": "We will take care of your business, so you can take care of your customers"
    },
    "contact": {
      "title": "Contact Us",
      "company": "Tech Colleagues"
    },
    "footer": {
      "about": "Sale Mobilizer helps businesses manage sales, stock, and customers from one system.",
      "builtBy": "Built by Tech Colleagues with focus on simple, practical, and reliable software.",
      "companyDescription": "Sale Mobilizer is a product of Tech Colleagues, an innovative technology company based in Islamabad.",
      "sections": {
        "product": "Product",
        "company": "Company",
        "legal": "Legal"
      },
      "toggleText": {
        "showMore": "Show more",
        "showLess": "Show less"
      }
    }
  },
  "subheadings": {
    "hero": {
      "description": "Fast billing and inventory control on your POS. Manage your business from your phone and let customers place orders through your app. Everything stays connected."
    },
    "apps": {
      "subtitle": "Everything connected"
    },
    "features": {
      "subtitle": "Everything you need to run your store"
    },
    "why": {
      "subtitle": "The POS system built for your success",
      "testimonialsSubtitle": "Results from businesses using Sale Mobilizer"
    },
    "pricing": {
      "subtitle": "We will take care of your business, so you can take care of your customers"
    }
  },
  "coreData": {
    "hero": {
      "videoSrc": "images/common/salevideo.mp4"
    },
    "apps": [
      {
        "title": "Admin App",
        "image": "admin-app.webp",
        "features": ["View sales live", "Control inventory remotely", "Get alerts"]
      },
      {
        "title": "POS System",
        "image": "pos-app.webp",
        "features": ["Fast billing", "Works offline", "Supports hardware"]
      },
      {
        "title": "Customer App",
        "image": "customer-app.webp",
        "features": ["Easy ordering", "Multiple payment options", "Real-time updates"]
      }
    ],
    "features": [
      {
        "title": "Accounting & Finance",
        "icon": "fa-calculator",
        "features": [
          { "title": "Chart of Accounts" },
          { "title": "Journal Entries" },
          { "title": "General Ledger" },
          { "title": "Accounts Payable" },
          { "title": "Accounts Receivable" }
        ]
      },
      {
        "title": "Sales & Customer Management",
        "icon": "fa-handshake",
        "features": [
          { "title": "Customer Management" },
          { "title": "Lead Management" },
          { "title": "Quotations" },
          { "title": "Sales Orders" },
          { "title": "Deliveries" }
        ]
      },
      {
        "title": "Procurement & Vendor Management",
        "icon": "fa-truck",
        "features": [
          { "title": "Vendor Management" },
          { "title": "Purchase Requests" },
          { "title": "Purchase Orders" },
          { "title": "Goods Receipts" },
          { "title": "Purchase Invoices" }
        ]
      },
      {
        "title": "Inventory Management",
        "icon": "fa-boxes-stacked",
        "features": [
          { "title": "Product Management" },
          { "title": "Warehouses" },
          { "title": "Stock Transfers" },
          { "title": "Stock Adjustments" },
          { "title": "Low Stock Alerts" }
        ]
      },
      {
        "title": "CRM",
        "icon": "fa-users",
        "features": [
          { "title": "Leads" },
          { "title": "Opportunities" },
          { "title": "Contacts" },
          { "title": "Activities" },
          { "title": "Calls & Meetings" }
        ]
      },
      {
        "title": "Human Resources",
        "icon": "fa-id-card",
        "features": [
          { "title": "Employee Records" },
          { "title": "Departments" },
          { "title": "Attendance Tracking" },
          { "title": "Leave Management" },
          { "title": "Payroll Processing" }
        ]
      },
      {
        "title": "Reports & Analytics",
        "icon": "fa-chart-line",
        "features": [
          { "title": "Financial Reports" },
          { "title": "Sales Reports" },
          { "title": "Inventory Reports" },
          { "title": "Custom Reports" },
          { "title": "Dashboard Analytics" }
        ]
      },
      {
        "title": "Administration",
        "icon": "fa-gear",
        "features": [
          { "title": "User Management" },
          { "title": "Roles & Permissions" },
          { "title": "System Settings" },
          { "title": "Audit Logs" },
          { "title": "API Integrations" }
        ]
      }
    ],
    "why": [
      {
        "icon": "fas fa-cube",
        "title": "Everything in One Place",
        "desc": "Sales, inventory, customers, and reports in a single system."
      },
      {
        "icon": "fas fa-mobile-alt",
        "title": "Mobile Access",
        "desc": "Check and manage your business from your phone."
      }
    ],
    "testimonials": [
      {
        "quote": "Everything is faster and more organized now.",
        "name": "Ali Raza",
        "company": "Retail Store",
        "role": "Owner",
        "image": "images/common/client1.png"
      },
      {
        "quote": "Stock management became simple and accurate.",
        "name": "Usman Khan",
        "company": "Wholesale Shop",
        "role": "Manager",
        "image": "images/common/client2.png"
      }
    ],
    "working": [
  {
    "id": "pos-sales",
    "name": "POS Desktop",
    "icon": "fas fa-shopping-cart",
    "screenshots": [
      { "name": "Active Sale", "image": "/images/screens/pos-screens/dashboard-screen.png" },
      { "name": "Payment Screen", "image": "/images/screens/pos-screens/hiring-request.png" }
    ]
  },
  {
    "id": "system-admin",
    "name": "ERP Admin",
    "icon": "fas fa-cogs",
    "screenshots": [
      { "name": "ERP Login", "image": "/images/screens/admin-screens/login.png" },
      { "name": "ERP Dashboard", "image": "/images/screens/admin-screens/dashboard.png" }
    ]
  },
  {
    "id": "navigation-analytics",
    "name": "Customer App",
    "icon": "fas fa-mobile-screen",
    "screenshots": [
      { "name": "Splash & Setup", "image": "/images/screens/customer-screens/dashboard-screen.png" },
      { "name": "Products", "image": "/images/screens/customer-screens/hiring-request.png" }
    ]
  }
],
   "pricing": [
  {
    "name": "Starter",
    "price": "Rs 15k",
    "features": [
      "Core Module",
      "Accounting Module",
      "Up to 5 Users",
      "Basic Reports"
    ],
    "highlight": false
  },
  {
    "name": "Professional",
    "price": "Rs 35k",
    "features": [
      "All Starter Features",
      "Sales",
      "CRM",
      "Mobile App",
      "Up to 25 Users"
    ],
    "highlight": true
  },
  {
    "name": "Enterprise",
    "price": "Custom",
    "features": [
      "Full ERP Suite",
      "Unlimited Users",
      "Custom Modules",
      "Dedicated Support"
    ],
    "highlight": false
  }
],
    "contact": {
      "aboutUs": "We build simple and reliable software to manage sales, stock, and business operations.",
      "companyName": "Tech Colleagues",
      "address": "Cloud Emporium, Executive block, Gulberg Greens, Islamabad",
      "email": "hr@techcolleagues.com",
      "phone": "+923000910043",
      "website": "https://techcolleagues.com",
      "googleMapsUrl": "https://maps.app.goo.gl/nvc6YVf8TQMPcQLE7"
    }
  },
  "ctaButtons": {
    "primary": {
      "meeting": {
        "text": "Book a Meeting",
        "url": "https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues",
        "target": "_blank"
      },
      "download": {
        "text": "Download & Try",
        "url": "https://salemobilizerstoragedev.z10.web.core.windows.net/",
        "target": "_blank"
      },
      "demo": {
        "text": "See Live Demo",
        "url": "https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues",
        "target": "_blank"
      }
    },
    "secondary": {
      "getStarted": "Get Started",
      "bookDemo": "Book Demo",
      "showMore": "Show More",
      "showLess": "Show Less"
    }
  },
  "ariaLabels": {
    "navigation": {
      "previousSlide": "Previous slide",
      "nextSlide": "Next slide",
      "previousImage": "Previous image",
      "nextImage": "Next image"
    }
  },
  "uiElements": {
    "navigation": [
      { "name": "Why Us", "url": "#apps" },
      { "name": "Features", "url": "#features" },
      { "name": "Working", "url": "#working" },
      { "name": "Pricing", "url": "#pricing" },
      { "name": "Contact", "url": "#contact" }
    ],
    "socialLinks": [
      { "name": "whatsapp", "icon": "fab fa-whatsapp", "url": "https://wa.me/923000910043" },
      { "name": "phone", "icon": "fas fa-phone", "url": "tel:+923000910043" },
      { "name": "instagram", "icon": "fab fa-instagram", "url": "https://www.instagram.com/techcolleagues.1?igsh=MW0zNXp2MjluM3pqbA==" },
      { "name": "facebook", "icon": "fab fa-facebook-f", "url": "https://www.facebook.com/share/1NBbSbn4eJ/" },
      { "name": "linkedin", "icon": "fab fa-linkedin-in", "url": "https://www.linkedin.com/company/tech-colleagues/" }
    ],
    "footerLinks": {
      "product": [
        { "name": "Download", "url": "https://salemobilizerstoragedev.z10.web.core.windows.net/" },
        { "name": "Features", "url": "#features" },
        { "name": "Support", "url": "#contact" }
      ],
      "company": [
        { "name": "About", "url": "#why" },
        { "name": "Contact", "url": "#contact" }
      ],
      "legal": [
        { "name": "Privacy Policy", "url": "#" },
        { "name": "Terms", "url": "#" }
      ]
    }
  },
  "media": {
    "logos": {
      "salemobilizer": { "src": "images/icons/erp-icon.png", "alt": "Sale Mobilizer" },
      "techColleagues": { "src": "images/common/techcolleagues-logo.png", "alt": "Tech Colleagues" }
    },
    "heroScreenshots": ["images/common/product1.png", "images/common/product2.png"],
    "heroTestimonials": [
      { "text": "Everything is under control now.", "name": "Ali Raza", "company": "Retail Shop", "img": "images/common/maxduran.png" },
      { "text": "Work is faster and easier.", "name": "Usman Khan", "company": "Store Owner", "img": "images/common/sara.png" }
    ],
    "paymentMethods": [
      { "name": "Visa", "src": "images/common/visa.png" },
      { "name": "Mastercard", "src": "images/common/mastercard.png" }
    ],
    "office": {
      "address": "Gulberg Greens, Islamabad",
      "image": "images/common/officebuilding.png"
    }
  },
  "metadata": {
    "company": {
      "name": "Tech Colleagues",
      "copyright": "© 2026 Tech Colleagues"
    },
    "product": {
      "name": "Sale Mobilizer",
      "description": "Fast billing and inventory control on your POS. Manage your business from your phone and let customers place orders through your app. Everything stays connected."
    }
  }
}